<template>
  <div>
    <vx-card style="margin-bottom: 20px">
      <b-card-text> Cari Adı: {{ ACTNAME }} </b-card-text>
      <vs-divider color="Default"> </vs-divider>
      <b-row align-v="center">
        <b-col lg="1" sm="12" align-self="center">
          <label for="datepicker-sm">Tarih: </label></b-col
        >

        <b-col lg="2" sm="5" align-self="center">
          <b-form-datepicker
            bottom
            v-model="datepickerbaslangic"
            :placeholder="getLastTreeMonth()"
            size="md"
            local="tr-TR"
            today-variant="danger"
            :start-weekday="weekday"
            :date-format-options="{
              year: 'numeric',
              month: 'numeric',
              day: 'numeric'
            }"
          />
        </b-col>
        <b-col lg="2" sm="5" align-self="center">
          <b-form-datepicker
            v-model="datepickerbitis"
            :placeholder="getNow()"
            size="md"
            local="tr-TR"
            today-variant="danger"
            :start-weekday="weekday"
            :date-format-options="{
              year: 'numeric',
              month: 'numeric',
              day: 'numeric'
            }"
          />
        </b-col>

        <b-col cols="7" style="padding: 0; padding-right: 20px">
          <b-row align-h="end">
            <b-col cols="12" md="auto" style="padding: 0"
              ><vs-chip transparent color="warning">
                Gün: {{ hesaplananGun }}</vs-chip
              >
            </b-col>
            <b-col cols="12" md="auto" style="padding: 0"
              ><vs-chip transparent color="primary">
                Satış Vade: {{ parseDate(SATISVADE) }}</vs-chip
              >
            </b-col>
            <b-col cols="12" md="auto" style="padding: 0"
              ><vs-chip transparent color="success">
                Ortalama Vade: {{ parseDate(ORTALAMAVADE) }}</vs-chip
              >
            </b-col>
            <b-col cols="12" md="auto" style="padding: 0"
              ><vs-chip transparent color="danger">
                Tahsilat Vade: {{ parseDate(TAHSILATVADE) }}</vs-chip
              >
            </b-col>
          </b-row>
        </b-col>

        <b-col lg="12" sm="12" style="padding-top: 20px; padding-right: 20px">
          <b-row align-h="start">
            <b-col cols="12" md="auto" style="margin-top: 5px">
              <vs-button
                v-on:click="listele()"
                line-origin="left"
                color="primary"
                type="gradient"
                style="font-weight: bold; border-radius: 5px"
                >Ekstre</vs-button
              >
            </b-col>
            <b-col cols="12" md="auto" style="margin-top: 5px"
              ><vs-button
                v-on:click="tahsilat()"
                line-origin="left"
                color="success"
                type="gradient"
                style="font-weight: bold; border-radius: 5px"
                >Tahsilat</vs-button
              >
            </b-col>
            <b-col cols="12" md="auto" style="margin-top: 5px">
              <vs-button
                v-on:click="tahsilatOzet()"
                line-origin="left"
                color="warning"
                type="gradient"
                style="font-weight: bold; border-radius: 5px"
                >Tahsilat Özet</vs-button
              >
            </b-col>
            <b-col cols="12" md="auto" style="margin-top: 5px">
              <vs-button
                @click="kisiEkle()"
                line-origin="left"
                color="primary"
                type="gradient"
                style="border-radius: 5px"
                icon="group_add"
                >İlgili Kişi Ekle</vs-button
              >
            </b-col>
            <b-col cols="12" md="auto" style="margin-top: 5px">
              <vs-button
                @click="gorusmeKaydiOlustur()"
                line-origin="left"
                color="success"
                type="gradient"
                style="border-radius: 5px"
                icon="call"
                >Görüşme Kaydı Oluştur</vs-button
              >
            </b-col>
            <b-col cols="12" md="auto" style="margin-top: 5px">
              <vs-button
                @click="aktiviteOlustur()"
                line-origin="left"
                color="danger"
                type="gradient"
                style="border-radius: 5px"
                icon="description"
                >Aktivite Oluştur</vs-button
              >
            </b-col>
            <b-col cols="12" md="auto" style="margin-top: 5px">
              <vs-button
                @click="resimEkle()"
                line-origin="left"
                color="#02a66d"
                gradient-color-secondary="rgb(1, 52, 74)"
                type="gradient"
                style="border-radius: 5px"
                icon="image"
                >Resim Ekle</vs-button
              >
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </vx-card>
    <vs-card :hidden="tahsilatValidate">
      <TahsilatComponent
        :datepickerbaslangic="datepickerbaslangic"
        :datepickerbitis="datepickerbitis"
        ref="tahsilatList"
      />
    </vs-card>
    <vx-card :hidden="listeleValidate">
      <b-row>
        <b-col lg="7" sm="12">
          <b-row align-h="start">
            <b-col cols="12" md="auto"
              ><vs-button
                line-origin="left"
                color="danger"
                type="gradient"
                style="
                  font-weight: bold;
                  border-radius: 5px;
                  padding-bottom: 7px;
                "
                ><download-excel
                  class="btn btn-default"
                  :data="cariHareketlerListesi"
                  name="excelData.xls"
                  style="
                    font-weight: bold;
                    width: 75px;
                    height: 25px;
                    text-align: center;
                    padding: 0px;
                    color: white;
                  "
                >
                  Excel
                </download-excel></vs-button
              >
            </b-col>
            <b-col cols="12" md="auto"
              ><vs-button
                line-origin="left"
                color="primary"
                type="gradient"
                style="font-weight: bold; border-radius: 5px"
                @click="ekstreMailGonder"
                >İndir/Mail Gönder</vs-button
              >
            </b-col>
          </b-row>
        </b-col>
      </b-row>

      <ag-grid-vue
        style="width: 100%; height: 500px; margin-top: 10px"
        class="ag-theme-alpine"
        :defaultColDef="defaultColDef"
        :columnDefs="cariHareketlerListesicolumns"
        :rowData="cariHareketlerListesi"
        :localeText="localeText"
        @grid-ready="onGridReady"
        @first-data-rendered="onFirstDataRendered"
        @rowDoubleClicked="faturaDetay"
        :pinnedBottomRowData="pinnedBottomRowData"
        :getRowStyle="getRowStyle"
      >
      </ag-grid-vue>
    </vx-card>
    <b-row>
      <vs-card>
        <b-row align-v="center">
          <b-col lg="12" sm="12" style="padding-right: 20px">
            <b-row align-h="center">
              <b-col cols="12" md="auto">
                <vs-button
                  v-on:click="ilgiliKisilerListele()"
                  color="primary"
                  line-origin="left"
                  type="line"
                  style="font-weight: bold; border-radius: 5px"
                  >İlgili Kişiler</vs-button
                >
              </b-col>
              <b-col cols="12" md="auto"
                ><vs-button
                  v-on:click="gorusmeKayitleriListele()"
                  color="success"
                  line-origin="left"
                  type="line"
                  style="font-weight: bold; border-radius: 5px"
                  >Görüşme Kayıtları</vs-button
                >
              </b-col>

              <b-col cols="12" md="auto">
                <vs-button
                  v-on:click="aktivitelerListele()"
                  line-origin="left"
                  color="danger"
                  type="line"
                  style="font-weight: bold; border-radius: 5px"
                  >Aktiviteler</vs-button
                >
              </b-col>
              <b-col cols="12" md="auto">
                <vs-button
                  v-on:click="resimlerListele()"
                  line-origin="left"
                  color="warning"
                  type="line"
                  style="font-weight: bold; border-radius: 5px"
                  >Resimler</vs-button
                >
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </vs-card>
    </b-row>
    <!-- tahsilat özet-->
    <vs-popup
      fullscreen
      type="filled"
      pazaryer
      title="Tahsilat Özet"
      :active.sync="popupKartDetay"
    >
      <vue-good-table
        :columns="columns"
        :rows="gruplananACT"
        :fixed-header="true"
        min-height="800px"
        :group-options="{
          enabled: true
        }"
      >
        <template slot="table-row" slot-scope="props">
          <div v-if="props.column.field === 'TARIH'" class="text-nowrap">
            <span class="text-nowrap">
              <div v-if="parseDate(props.row.TARIH) != '01.01.1900'">
                {{ parseDate(props.row.TARIH) }}
              </div>
            </span>
          </div>
          <div v-else-if="props.column.field === 'TVADE'" class="text-nowrap">
            <span class="text-nowrap">
              <div v-if="parseDate(props.row.TVADE) != '01.01.1900'">
                {{ parseDate(props.row.TVADE) }}
              </div>
            </span>
          </div>

          
          
          <div
            v-else-if="props.column.field === 'BORCVADE'"
            class="text-nowrap"
          >
            <span class="text-nowrap">
              <div v-if="parseDate(props.row.BORCVADE) != '01.01.1900'">
                {{ parseDate(props.row.BORCVADE) }}
              </div>
            </span>
          </div>
          <div
            v-else-if="props.column.field === 'ALACAKVADE'"
            class="text-nowrap"
          >
            <span class="text-nowrap">
              <div v-if="parseDate(props.row.ALACAKVADE) != '01.01.1900'">
                {{ parseDate(props.row.ALACAKVADE) }}
              </div>
            </span>
          </div>
        </template>
        <!--
        <template slot="table-header-row" slot-scope="props">
          <span class="my-fancy-class">
            {{ props.row.TARIH }}
          </span>
        </template>-->
      </vue-good-table>
    </vs-popup>
    <!--mail gönder-->
    <vs-popup
      fullscreen
      type="filled"
      pazaryer
      title="Mail Gönder"
      :active.sync="popupEkstreDetay"
    >
      <div>
        <b-row>
          <vs-card>
            <b-col lg="7" sm="12" style="padding: 0; padding-right: 20px">
              <b-row align-h="start">
                <b-col cols="12" md="auto"
                  ><vs-input
                    style="
                      padding: 0.4rem !important;
                      margin-top: 0;
                      width: 400px;
                    "
                    icon-after="true"
                    icon="email"
                    label-placeholder="E-Mail"
                    v-model="girilenMail"
                  />
                </b-col>

                <b-col cols="12" md="auto">
                  <vs-button
                    @click="mailBtnGonder()"
                    color="primary"
                    icon="send"
                    type="flat"
                    id="button-with-loading-yeni"
                    class="vs-con-loading__container"
                  ></vs-button>
                </b-col>
              </b-row>
            </b-col>

            <b-row style="padding: 15px">
              <b-col lg="12">
                <vs-table :data="mailListesi" max-height="250px">
                  <template slot="thead">
                    <vs-th style="background-color: #e8e8fa" sort-key="EMAIL"
                      >E-Mail</vs-th
                    >
                    <vs-th style="background-color: #e8e8fa" sort-key="YETKILI"
                      >Yetkili</vs-th
                    >
                    <vs-th style="background-color: #e8e8fa" sort-key="MISSION"
                      >Görev</vs-th
                    >
                    <vs-th style="background-color: #e8e8fa"></vs-th>
                  </template>

                  <template slot-scope="{ data }">
                    <vs-tr :key="indextr" v-for="(tr, indextr) in data" s>
                      <vs-td
                        style="font-size: small"
                        :data="data[indextr].EMAIL"
                      >
                        {{ data[indextr].EMAIL }}
                      </vs-td>
                      <vs-td
                        style="font-size: small"
                        :data="data[indextr].YETKILI"
                      >
                        {{ data[indextr].YETKILI }}
                      </vs-td>
                      <vs-td
                        style="font-size: small"
                        :data="data[indextr].MISSION"
                      >
                        {{ data[indextr].MISSION }}
                      </vs-td>
                      <vs-td>
                        <vs-button
                          @click="mailBtnGonder(data[indextr].EMAIL)"
                          color="primary"
                          icon="send"
                          type="flat"
                        ></vs-button>
                      </vs-td>
                    </vs-tr>
                  </template>
                </vs-table>
              </b-col>
            </b-row>
          </vs-card>
        </b-row>
      </div>
      <div id="invoice-page" style="min-height: 350px">
        <div class="items-center justify-between">
          <div class="items-center">
            <CariTahsilatEkstreMail ref="ekstreRef" />
          </div>
        </div>
      </div>

    </vs-popup>
    <!--modal ilgili kişi kayıt-->
    <b-modal
      ref="modal-kisiekle"
      id="modal-primary"
      modal-class="modal-primary"
      centered
      title="İlgili Kişi Ekle"
      size="lg"
    >
      <div>
        <b-row>
          <b-col>
            <vs-card>
              <b-form @submit.prevent>
                <b-row style="margin-bottom: 10px">
                  <b-col cols="4" align-self="center">
                    <b-form-group
                      label="İlgili Kişi Ad"
                      label-for="h-first-name"
                      style="font-size: 15px"
                    >
                    </b-form-group>
                  </b-col>
                  <b-col cols="8">
                    <b-form-input id="h-first-name" v-model="ilgiliKisiAd" />
                  </b-col>
                </b-row>
                <b-row style="margin-bottom: 10px">
                  <b-col cols="4" align-self="center">
                    <b-form-group
                      label="İlgili Kişi Soyad"
                      label-for="h-first-name"
                      style="font-size: 15px"
                    >
                    </b-form-group>
                  </b-col>
                  <b-col cols="8">
                    <b-form-input id="h-first-name" v-model="ilgiliKisiSoyad" />
                  </b-col>
                </b-row>
                <b-row style="margin-bottom: 10px">
                  <b-col cols="4" align-self="center">
                    <b-form-group
                      label="İlgili Kişi Ünvan"
                      label-for="h-first-name"
                      style="font-size: 15px"
                    >
                    </b-form-group>
                  </b-col>
                  <b-col cols="8">
                    <b-form-input id="h-first-name" v-model="ilgiliKisiUnvan" />
                  </b-col>
                </b-row>
                <b-row style="margin-bottom: 10px">
                  <b-col cols="4" align-self="center">
                    <b-form-group
                      label="İlgili Kişi Telefon"
                      label-for="h-first-name"
                      style="font-size: 15px"
                    >
                    </b-form-group>
                  </b-col>
                  <b-col cols="8">
                    <b-form-input
                      id="h-first-name"
                      v-model="ilgiliKisiTelefon"
                    />
                  </b-col>
                </b-row>
                <b-row style="margin-bottom: 10px">
                  <b-col cols="4" align-self="center">
                    <b-form-group
                      label="İlgili Kişi Cep Telefonu"
                      label-for="h-first-name"
                      style="font-size: 15px"
                    >
                    </b-form-group>
                  </b-col>
                  <b-col cols="8">
                    <b-form-input
                      id="h-first-name"
                      v-model="ilgiliKisiCepTelefon"
                    />
                  </b-col>
                </b-row>
                <b-row style="margin-bottom: 10px">
                  <b-col cols="4" align-self="center">
                    <b-form-group
                      label="E-Mail"
                      label-for="h-first-name"
                      style="font-size: 15px"
                    >
                    </b-form-group>
                  </b-col>
                  <b-col cols="8">
                    <b-form-input id="h-first-name" v-model="ilgiliKisiEmail" />
                  </b-col>
                </b-row>
              </b-form>
            </vs-card>
          </b-col>
        </b-row>
      </div>
      <template #modal-footer>
        <div class="w-100">
          <vs-button
            class="float-right"
            @click="cancel()"
            line-origin="left"
            color="danger"
            type="gradient"
            style="border-radius: 5px"
            icon="close"
            >İptal</vs-button
          >
          <vs-button
            class="float-right"
            @click="ilgiliKisiKaydet('')"
            line-origin="left"
            color="primary"
            type="gradient"
            style="border-radius: 5px"
            icon="done"
            >İlgili Kişiyi Kaydet</vs-button
          >
        </div>
      </template>
    </b-modal>
    <!--modal görüşme kayıt-->
    <b-modal
      ref="modal-gorusme"
      id="modal-primary"
      modal-class="modal-primary"
      centered
      title="Görüşme Kaydı Ekle"
      size="lg"
    >
      <div>
        <b-row>
          <b-col>
            <vs-card>
              <b-form @submit.prevent>
                <b-row style="margin-bottom: 10px">
                  <b-col cols="4" align-self="center">
                    <b-form-group
                      label="Görüşme Tipi"
                      label-for="h-first-name"
                      style="font-size: 15px"
                    >
                    </b-form-group>
                  </b-col>
                  <b-col cols="8">
                    <v-select
                      color="danger"
                      v-model="gorusmeTipi"
                      :options="gorusmeTipleri"
                      label="name"
                      autocomplete
                      ref="selectElement"
                    >
                    </v-select>
                  </b-col>
                </b-row>
                <b-row style="margin-bottom: 10px">
                  <b-col cols="4" align-self="center">
                    <b-form-group
                      label="Görüşülen Kişi"
                      label-for="h-first-name"
                      style="font-size: 15px"
                    >
                    </b-form-group>
                  </b-col>
                  <b-col cols="8">
                    <b-form-input id="h-first-name" v-model="gorusulenKisi" />
                  </b-col>
                </b-row>
                <b-row style="margin-bottom: 10px">
                  <b-col cols="4" align-self="center">
                    <b-form-group
                      label="Müşteri Notları"
                      label-for="h-first-name"
                      style="font-size: 15px"
                    >
                    </b-form-group>
                  </b-col>
                  <b-col cols="8">
                    <vs-textarea
                      class="form-control"
                      label="Müşteri Notu (En fazla 400 karakter)"
                      v-on:keyup="countdown2"
                      v-model="musteriNotlari"
                    />
                    <p
                      class="text-right text-small"
                      v-bind:class="{ 'text-danger': hasError2 }"
                    >
                      {{ remainingCount2 }}
                      <span
                        v-if="hasError2"
                        v-bind:class="{ 'text-danger': hasError2 }"
                      >
                        karakter sayısını aştınız</span
                      >
                    </p>
                  </b-col>
                </b-row>
                <b-row style="margin-bottom: 10px">
                  <b-col cols="4" align-self="center">
                    <b-form-group
                      label="Açıklama"
                      label-for="h-first-name"
                      style="font-size: 15px"
                    >
                    </b-form-group>
                  </b-col>
                  <b-col cols="8">
                    <b-form-input
                      id="h-first-name"
                      v-model="gorusulenAciklama"
                    />
                  </b-col>
                </b-row>
                <b-row style="margin-bottom: 10px">
                  <b-col cols="4" align-self="center">
                    <b-form-group
                      label="Personel Notu"
                      label-for="h-first-name"
                      style="font-size: 15px"
                    >
                    </b-form-group>
                  </b-col>
                  <b-col cols="8">
                    <vs-textarea
                      class="form-control"
                      label="Personel Notu (En fazla 400 karakter)"
                      v-on:keyup="countdown"
                      v-model="personelNotu"
                    />
                    <p
                      class="text-right text-small"
                      v-bind:class="{ 'text-danger': hasError }"
                    >
                      {{ remainingCount }}
                      <span
                        v-if="hasError"
                        v-bind:class="{ 'text-danger': hasError }"
                      >
                        karakter sayısını aştınız</span
                      >
                    </p>
                  </b-col>
                </b-row>
                <b-row style="margin-bottom: 10px">
                  <b-col cols="4" align-self="center">
                    <b-form-group
                      label="Görüşme Tarihi"
                      label-for="h-first-name"
                      style="font-size: 15px"
                    >
                    </b-form-group>
                  </b-col>
                  <b-col cols="8">
                    <b-form-datepicker
                      bottom
                      v-model="gorusmeTarihi"
                      size="md"
                      today-variant="danger"
                      :start-weekday="weekday"
                      :date-format-options="{
                        year: 'numeric',
                        month: 'numeric',
                        day: 'numeric'
                      }"
                    />
                  </b-col>
                </b-row>
              </b-form>
            </vs-card>
          </b-col>
        </b-row>
      </div>
      <template #modal-footer>
        <div class="w-100">
          <vs-button
            class="float-right"
            @click="cancel()"
            line-origin="left"
            color="danger"
            type="gradient"
            style="border-radius: 5px"
            icon="close"
            >İptal</vs-button
          >
          <vs-button
            class="float-right"
            @click="gorusmeKaydet()"
            line-origin="left"
            color="primary"
            type="gradient"
            style="border-radius: 5px"
            icon="done"
            >Görüşmeyi Kaydet</vs-button
          >
        </div>
      </template>
    </b-modal>
    <!--aktivite ekle-->
    <b-modal
      ref="modal-aktivite"
      id="modal-primary"
      modal-class="modal-primary"
      centered
      title="Aktivite Ekle"
      size="lg"
    >
      <div>
        <b-row>
          <b-col>
            <vs-card>
              <b-form @submit.prevent>
                <b-row style="margin-bottom: 10px">
                  <b-col cols="4" align-self="center">
                    <b-form-group
                      label="Alıcı"
                      label-for="h-first-name"
                      style="font-size: 15px"
                    >
                    </b-form-group>
                  </b-col>
                  <b-col cols="8">
                    <v-select
                      color="danger"
                      v-model="aktiviteAlici"
                      :options="personelOptions"
                      label="EMPLOYEENAME"
                      autocomplete
                      ref="selectElement"
                    >
                    </v-select>
                  </b-col>
                </b-row>
                <b-row style="margin-bottom: 10px">
                  <b-col cols="4" align-self="center">
                    <b-form-group
                      label="Aktivite Tipi"
                      label-for="h-first-name"
                      style="font-size: 15px"
                    >
                    </b-form-group>
                  </b-col>
                  <b-col cols="8">
                    <v-select
                      color="danger"
                      v-model="aktiviteTipi"
                      :options="gorusmeTipleri"
                      label="name"
                      autocomplete
                      ref="selectElement"
                    >
                    </v-select>
                  </b-col>
                </b-row>

                <b-row style="margin-bottom: 10px">
                  <b-col cols="4" align-self="center">
                    <b-form-group
                      label="Aktivite Durumu"
                      label-for="h-first-name"
                      style="font-size: 15px"
                    >
                    </b-form-group>
                  </b-col>
                  <b-col cols="8">
                    <v-select
                      color="danger"
                      v-model="aktiviteDurumu"
                      :options="durumOptions"
                      label="name"
                      autocomplete
                      ref="selectElement"
                    >
                    </v-select>
                  </b-col>
                </b-row>
                <b-row style="margin-bottom: 10px">
                  <b-col cols="4" align-self="center">
                    <b-form-group
                      label="Aktivite Notu"
                      label-for="h-first-name"
                      style="font-size: 15px"
                    >
                    </b-form-group>
                  </b-col>
                  <b-col cols="8">
                    <vs-textarea
                      class="form-control"
                      label="Müşteri Notu (En fazla 400 karakter)"
                      v-on:keyup="countdown3"
                      v-model="aktiviteNotu"
                    />
                    <p
                      class="text-right text-small"
                      v-bind:class="{ 'text-danger': hasError3 }"
                    >
                      {{ remainingCount3 }}
                      <span
                        v-if="hasError3"
                        v-bind:class="{ 'text-danger': hasError3 }"
                      >
                        karakter sayısını aştınız</span
                      >
                    </p>
                  </b-col>
                </b-row>
                <b-row style="margin-bottom: 10px">
                  <b-col cols="4" align-self="center">
                    <b-form-group
                      label="Tarih/Saat"
                      label-for="h-first-name"
                      style="font-size: 15px"
                    >
                    </b-form-group>
                  </b-col>
                  <b-col cols="8">
                    <b-row>
                      <b-col>
                        <b-form-datepicker
                          bottom
                          v-model="aktiviteTarihi"
                          size="md"
                          today-variant="danger"
                          :start-weekday="weekday"
                          :date-format-options="{
                            year: 'numeric',
                            month: 'numeric',
                            day: 'numeric'
                          }"
                        />
                      </b-col>
                      <b-col
                        ><b-form-timepicker v-model="aktiviteSaati"
                      /></b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </b-form>
            </vs-card>
          </b-col>
        </b-row>
      </div>
      <template #modal-footer>
        <div class="w-100">
          <vs-button
            class="float-right"
            @click="cancel()"
            line-origin="left"
            color="danger"
            type="gradient"
            style="border-radius: 5px"
            icon="close"
            >İptal</vs-button
          >
          <vs-button
            class="float-right"
            @click="aktiviteKaydet()"
            line-origin="left"
            color="primary"
            type="gradient"
            style="border-radius: 5px"
            icon="done"
            >Aktiviteyi Kaydet</vs-button
          >
        </div>
      </template>
    </b-modal>
    <!--resim ekle-->
    <vs-prompt
      title="Görüşme Resim Ekle"
      acceptText="Ekle"
      cancelText="Vazgeç"
      @accept="resimEkleOnay"
      :active.sync="activePrompt"
    >
      <div class="con-exemple-prompt">
        <b-row style="margin-top: 20px">
          <span>Resim Ekle</span>
          <vs-divider color="Default"> </vs-divider>
          <div class="centerx">
            <!--  <vs-upload
              style="padding: 0"
              automatic
              action="https://jsonplaceholder.typicode.com/posts/"
              @change="onFileChange"
            />-->
            <v-select
              color="danger"
              v-model="gorusmeResimSelected"
              :options="gorusmeResimOptions"
              label="ZIYARET"
              autocomplete
            >
            </v-select>
            <vs-divider color="Default"> </vs-divider>
            <input
              type="file"
              accept="image/*"
              @change="onFileChange"
              id="file-input"
            />
          </div>
        </b-row>
      </div>
    </vs-prompt>
    <!--ilgili kişiler listesi-->
    <b-modal
      ref="modal-ilgiliKisiListesi"
      id="modal-primary"
      modal-class="modal-primary"
      centered
      title="İlgili Kişiler Listesi"
      size="xl"
      hide-footer
    >
      <div v-if="tableValidate == 'İlgili Kişiler'">
        <ag-grid-vue
          style="width: 100%; height: 500px; margin-top: 10px"
          class="ag-theme-alpine"
          :defaultColDef="defaultColDef"
          :columnDefs="ilgiliKisilerColumn"
          :rowData="ilgiliKisilerRowData"
          :localeText="localeText"
          @grid-ready="onGridReady"
          @first-data-rendered="onFirstDataRendered"
        >
        </ag-grid-vue>
      </div>
    </b-modal>
    <!--görüşme listesi-->
    <b-modal
      ref="modal-gorusmeListesi"
      id="modal-primary"
      modal-class="modal-primary"
      centered
      title="Görüşme Listesi"
      size="xl"
      hide-footer
    >
      <div v-if="tableValidate == 'Görüşme Kayıtları'">
        <ag-grid-vue
          style="width: 100%; height: 500px; margin-top: 10px"
          class="ag-theme-alpine"
          :defaultColDef="defaultColDef"
          :columnDefs="gorusmelerColumn"
          :rowData="gorusmelerRowData"
          :localeText="localeText"
          @grid-ready="onGridReady"
          @first-data-rendered="onFirstDataRendered"
        >
        </ag-grid-vue>
      </div>
    </b-modal>
    <!--aktivite listesi-->
    <b-modal
      ref="modal-aktiviteListesi"
      id="modal-primary"
      modal-class="modal-primary"
      centered
      title="Aktivite Listesi"
      size="xl"
      hide-footer
    >
      <div v-if="tableValidate == 'Aktiviteler'">
        <ag-grid-vue
          style="width: 100%; height: 500px; margin-top: 10px"
          class="ag-theme-alpine"
          :defaultColDef="defaultColDef"
          :columnDefs="aktivitelerColumn"
          :rowData="aktivitelerRowData"
          :localeText="localeText"
          @grid-ready="onGridReady"
          @first-data-rendered="onFirstDataRendered"
        >
        </ag-grid-vue>
      </div>
    </b-modal>

    <!--resim listesi-->
    <vs-popup
      fullscreen
      type="filled"
      title="Resimler Listesi"
      :active.sync="popupResimlerListesi"
    >
      <div v-if="tableValidate == 'Resimler'">
        <b-row>
          <b-col
            lg="3"
            sm="6"
            :key="index"
            v-for="(item, index) in resimListesi"
          >
            <vs-card>
              <img
                style="width: 100%"
                v-bind:src="bindimage + item.URL"
                class="grid-view-img px-4"
              />
            </vs-card>
          </b-col>
        </b-row>
      </div>
    </vs-popup>
  </div>
</template>
<script>
import vSelect from "vue-select";
import Store from "../../store/store";
import state from "../../store/state";
import IlgiliKisiButon from "../components/crm-components/finans-components/IlgiliKisiButon.vue";
import TahsilatComponent from "../components/crm-components/finans-components/TahsilatComponent.vue";
import CariTahsilatEkstreMail from "../components/crm-components/finans-components/CariTahsilatEkstreMail.vue";
import userJson from "../../../public/user.json";
import { isMobile } from "mobile-device-detect";
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import moment from "moment";
import user from "../../../public/user.json";
import {
  BButton,
  BModal,
  VBModal,
  BFormDatepicker,
  BTabs,
  BTab,
  BCardText
} from "bootstrap-vue";

export default {
  data() {
    return {
      SATISVADE: "",
      ORTALAMAVADE: "",
      TAHSILATVADE: "",

      hasError3: false,
      hasError2: false,
      hasError: false,
      maxCount: 400,
      remainingCount: 400,

      remainingCount2: 400,

      remainingCount3: 400,

      imageFileName: "",
      gorusmeResimSelected: "",
      gorusmeResimOptions: [],
      bindimage: userJson.stockImage,
      tableValidate: "İlgili Kişiler",
      resimListesi: [],

      ilgiliKisilerColumn: [],
      ilgiliKisilerRowData: [],

      gorusmelerColumn: [],
      gorusmelerRowData: [],

      aktivitelerColumn: [],
      aktivitelerRowData: [],

      girilenMail: "",
      mailListesi: [],
      popupEkstreDetay: false,
      pinnedBottomRowData: null,
      defaultColDef: {
        sortable: true,
        resizable: true
      },
      popupKartDetay: false,
      popupResimlerListesi: false,
      groupDefaultExpanded: null,
      rowClassRules: null,
      weekday: 1,

      localeText: null,
      columnDefs: null,
      rowData: null,
      isMobile: function() {
        return isMobile;
      },
      listeleValidate: false,
      tahsilatValidate: true,
      datepickerbaslangic: "",
      datepickerbitis: "",
      ACTNAME: "",
      ACTID: "",
      dir: false,
      cariHareketlerListesi: [],
      cariHareketlerListesicolumns: [],
      columns: [
        {
          label: "İşlem",
          field: "ISLEM"
        },
        {
          label: "Tür",
          field: "TTUR"
        },
        {
          label: "Fatura Ay",
          field: "FAY"
        },
        {
          label: "Fatura Yıl",
          field: "FYIL"
        },
        {
          label: "Ödenecek Ay",
          field: "BAY"
        },
        {
          label: "Ödenecek Yıl",
          field: "BYIL"
        },
        {
          label: "Ödenecek Tutar",
          field: "BTUTAR"
        },
        {
          label: "Tahsilat Vade",
          field: "TVADE"
        },
        {
          label: "Tahsilat Gun",
          field: "TGUN"
        },
        {
          label: "Tahsilat Tutar",
          field: "TTUTAR"
        },
        {
          label: "Borc Toplam",
          field: "BORCTOPLAM"
        },
        {
          label: "Tahsilat Toplam",
          field: "ALACAKTOPLAM"
        },
        {
          label: "Toplam Borcun Vadesi",
          field: "BORCVADE"
        },
        {
          label: "Tahsilat Vadesi",
          field: "ALACAKVADE"
        },
        {
          label: "Açıklama",
          field: "ACIKLAMA"
        }
      ],
      hesaplananGun: "",
      gruplananActname: [],
      gruplananACT: [],
      topBORC: 0.0,
      topALACAK: 0.0,
      topBAKIYE: 0.0,
      getRowStyle: null,

      ilgiliKisiAd: "",
      ilgiliKisiSoyad: "",
      ilgiliKisiUnvan: "",
      ilgiliKisiTelefon: "",
      ilgiliKisiCepTelefon: "",
      ilgiliKisiEmail: "",
      ilgiliKisilerListesi: [],

      activePrompt: false,
      aktiviteSaati: "",
      aktiviteTarihi: "",
      aktiviteNotu: "",
      aktiviteDurumu: "",
      aktiviteTipi: "",
      aktiviteAlici: "",
      personelOptions: [],
      durumOptions: [
        { value: "2", name: "Aktif" },
        { value: "3", name: "Pasif" }
      ],

      gorusmeTipi: "",
      gorusulenKisi: "",
      musteriNotlari: "",
      gorusulenAciklama: "",
      personelNotu: "",
      gorusmeTarihi: "",
      gorusmeTipleri: [
        { value: "0", name: "Görüşme Tipi Seçiniz" },
        { value: "2530110", name: "Telefon" },
        { value: "2530120", name: "Mektup" },
        { value: "2530130", name: "Faks" },
        { value: "2530140", name: "E-Posta" },
        { value: "2530150", name: "Ziyaret" },
        { value: "2530160", name: "Genel" },
        { value: "2530170", name: "Fuar" },
        { value: "2530180", name: "Seminer" }
      ]
    };
  },
  beforeRouteLeave(to, from, next) {
    next();

    const vs = this.$vs;
    vs.notify({
      text:
        "Sayfadan ayrılmak üzeresiniz, tahsilat işlemleriniz kaybolacaktır.",
      iconPack: "feather",
      icon: "icon-alert-circle",
      color: "danger",
      position: "top-center"
    });

    const arguman = {
      id: 0,
      index: 0,
      islemselected: "",
      bankaText: "",
      CekNo: "",
      tutar: "",
      vade: "",
      gun: "",
      disable: false
    };
    this.$store.commit("account/ITEM_ITEMLIST", arguman);
  },
  methods: {
    countdown3() {
      this.remainingCount3 = this.maxCount - this.aktiviteNotu.length;
      this.hasError3 = this.remainingCount3 < 0;
    },
    countdown2() {
      this.remainingCount2 = this.maxCount - this.musteriNotlari.length;
      this.hasError2 = this.remainingCount2 < 0;
    },
    countdown() {
      this.remainingCount = this.maxCount - this.personelNotu.length;
      this.hasError = this.remainingCount < 0;
    },
    resimlerListele() {
      this.popupResimlerListesi = true;
      var vm = this;
      vm.tableValidate = "Resimler";
      const soap = require("soap");
      const url = state.sistemAddress;
      var args = {
        token: Store.state.tokenId,
        ACTID: vm.ACTID
      };
      soap.createClient(url, function(err, client) {
        client.INT_RESIMLER(args, function(err, result) {
          if (result.INT_RESIMLERResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          try {
            vm.veriler = JSON.parse(result.INT_RESIMLERResult);

            var list = JSON.parse(vm.veriler.jsonData);
            vm.resimListesi = list;
          } catch (error) {}
        });
      });
    },

    aktivitelerListele() {
      this.$refs["modal-aktiviteListesi"].show();
      var vm = this;
      vm.tableValidate = "Aktiviteler";
      const soap = require("soap");
      const url = state.sistemAddress;
      var args = {
        token: Store.state.tokenId,
        ACTID: vm.ACTID
      };
      soap.createClient(url, function(err, client) {
        client.INT_AKTIVITELER(args, function(err, result) {
          if (result.INT_AKTIVITELERResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          try {
            vm.veriler = JSON.parse(result.INT_AKTIVITELERResult);

            var list = JSON.parse(vm.veriler.jsonData);
            vm.aktivitelerRowData = list;
          } catch (error) {}
        });
      });
    },
    gorusmeKayitleriListele() {
      this.$refs["modal-gorusmeListesi"].show();
      var vm = this;
      vm.tableValidate = "Görüşme Kayıtları";
      const soap = require("soap");
      const url = state.sistemAddress;
      var args = {
        token: Store.state.tokenId,
        ACTID: vm.ACTID
      };
      soap.createClient(url, function(err, client) {
        client.INT_GORUSME_KAYITLARI(args, function(err, result) {
          if (result.INT_GORUSME_KAYITLARIResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          try {
            vm.veriler = JSON.parse(result.INT_GORUSME_KAYITLARIResult);
            var list = JSON.parse(vm.veriler.jsonData);
            vm.gorusmelerRowData = list;
          } catch (error) {}
        });
      });
    },
    ilgiliKisilerListele() {
      this.$refs["modal-ilgiliKisiListesi"].show();
      var vm = this;
      vm.tableValidate = "İlgili Kişiler";
      const soap = require("soap");
      const url = state.sistemAddress;
      var args = {
        token: Store.state.tokenId,
        ACTID: vm.ACTID
      };
      soap.createClient(url, function(err, client) {
        client.INT_ILGILI_KISILER(args, function(err, result) {
          if (result.INT_ILGILI_KISILERResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          try {
            vm.veriler = JSON.parse(result.INT_ILGILI_KISILERResult);
            var list = JSON.parse(vm.veriler.jsonData);
            vm.ilgiliKisilerRowData = list;
          } catch (error) {}
        });
      });
    },
    onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.createImage(files[0]);
    },
    createImage(file) {
      var image = new Image();
      var reader = new FileReader();
      var vm = this;
      reader.onload = e => {
        vm.image = e.target.result;
        vm.imageFileName = file.name;

        vm.upload(e.target.result, file.name);
      };
      reader.readAsDataURL(file);
    },
    upload(f, fileName) {
      var vm = this;
      var vs = this.$vs;
      const soap = require("soap");
      let url = state.sistemAddress;
      url = url.replace("sistem", "upload");
      var letters = {
        İ: "I",
        I: "I",
        Ş: "S",
        Ğ: "G",
        Ü: "U",
        Ö: "O",
        Ç: "C",
        ı: "i",
        ş: "s",
        ğ: "g",
        ü: "u",
        ö: "o",
        ç: "c"
      };
      var args = {
        f: f,
        stokKodu: "", // this.pictureBarcode,
        barkod: "",
        fileName: fileName.replace(/(([İIŞĞÜÇÖışğüöç]))/g, function(letter) {
          return letters[letter];
        })
      };

      soap.createClient(url, function(err, client) {
        client.uploadFileGorusme(args, function(err, result) {
          vs.notify({
            text: result,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-center",
            fixed: true
          });
          /*       vs.notify({
            text: fileName,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-center",
            fixed: true,
          });*/
        });
      });
    },

    resimEkleOnay() {
      // gorusmeResimOptions.

      var vm = this;
      var vs = this.$vs;
      const soap = require("soap");
      const url = state.sistemAddress;
      if (vm.imageFileName == "") {
        vs.notify({
          title: "Uyarı",
          text: "Dosya seçimi yapmadınız.",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
          position: "top-center"
        });
      } else if (vm.gorusmeResimSelected == "") {
        vs.notify({
          title: "Uyarı",
          text: "Dosya seçimi yapmadınız.",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
          position: "top-center"
        });
      } else {
        var args = {
          token: Store.state.tokenId,
          ACTID: vm.ACTID,
          ZIYARET: vm.gorusmeResimSelected.ZIYARET,
          ACTEVENTSID: vm.gorusmeResimSelected.ACTEVENTSID,
          fileName: vm.imageFileName
        };
        soap.createClient(url, function(err, client) {
          client.INT_INS_GORUSME_RESIMLERI(args, function(err, result) {
            if (result.INT_INS_GORUSME_RESIMLERIResult == "-1") {
              Store.dispatch("logout");
              //this.$store.dispatch('login', payload)
            }
            try {
              vm.veriler = JSON.parse(result.INT_INS_GORUSME_RESIMLERIResult);
              if (vm.veriler.response == "Ok") {
                vs.notify({
                  title: "Başarılı",
                  text: "Resim kaydı başarılı.",
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "success",
                  position: "top-center"
                });
              }
            } catch (error) {}
          });
        });
      }
    },
    resimEkle() {
      this.activePrompt = true;
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      var args = {
        token: Store.state.tokenId,
        ACTID: vm.ACTID
      };
      soap.createClient(url, function(err, client) {
        client.INT_GORUSME_RESIMLERI(args, function(err, result) {
          if (result.INT_GORUSME_RESIMLERIResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          try {
            vm.veriler = JSON.parse(result.INT_GORUSME_RESIMLERIResult);
            var list = JSON.parse(vm.veriler.jsonData);
            vm.gorusmeResimOptions = list;
          } catch (error) {}
        });
      });
    },
    aktiviteKaydet() {
      var vm = this;
      var vs = this.$vs;
      const soap = require("soap");
      const url = state.sistemAddress;
      if (vm.aktiviteAlici == "") {
        vs.notify({
          title: "Uyarı",
          text: "Alıcı değeri girmediniz",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
          position: "top-center"
        });
      } else if (vm.aktiviteTarihi == "") {
        vs.notify({
          title: "Uyarı",
          text: "Aktivite tarihi zorunludur",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
          position: "top-center"
        });
      } else if (vm.aktiviteSaati == "") {
        vs.notify({
          title: "Uyarı",
          text: "Aktivite saati zorunludur",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
          position: "top-center"
        });
      } else {
        var args = {
          token: Store.state.tokenId,
          aktiviteAlici: vm.aktiviteAlici.EMPLOYEEID,
          aktiviteNotu: vm.aktiviteNotu,
          aktiviteTipi: vm.aktiviteTipi.value,
          aktiviteDurumu: vm.aktiviteDurumu.value,
          aktiviteTarihi: vm.aktiviteTarihi,
          aktiviteSaati: vm.aktiviteSaati,
          aktiviteId: "",
          userId: Store.state.UserId,
          ACTID: vm.ACTID
        };
        soap.createClient(url, function(err, client) {
          client.INT_INS_AKTIVITE(args, function(err, result) {
            if (result.IINT_INS_AKTIVITEResult == "-1") {
              Store.dispatch("logout");
              //this.$store.dispatch('login', payload)
            }
            try {
              vm.veriler = JSON.parse(result.INT_INS_AKTIVITEResult);
              if (vm.veriler.response == "Ok") {
                vs.notify({
                  title: "Başarılı",
                  text: vm.veriler.message,
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "success",
                  position: "top-center"
                });
                vm.aktiviteSaati = "";
                vm.aktiviteTarihi = "";
                vm.aktiviteNotu = "";
                vm.aktiviteDurumu = "";
                vm.aktiviteTipi = "";
                vm.aktiviteAlici = "";
                vm.$refs["modal-aktivite"].hide();
              } else {
                vs.notify({
                  title: "Uyarı",
                  text: vm.veriler.message,
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "warning",
                  position: "top-center"
                });
              }
            } catch (error) {}
          });
        });
      }
    },
    aktiviteOlustur() {
      this.getPersonelList();
      this.$refs["modal-aktivite"].show();
    },
    getPersonelList() {
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      var args = {
        token: Store.state.tokenId
      };
      soap.createClient(url, function(err, client) {
        client.INT_PERSONELLER(args, function(err, result) {
          if (result.INT_PERSONELLERResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          try {
            vm.veriler = JSON.parse(result.INT_PERSONELLERResult);
            vm.personelOptions = JSON.parse(vm.veriler.jsonData);
          } catch (error) {}
        });
      });
    },
    gorusmeKaydet() {
      var vm = this;
      var vs = this.$vs;
      const soap = require("soap");
      const url = state.sistemAddress;
      if (
        vm.gorusmeTipi == "" ||
        vm.gorusmeTarihi == "" ||
        vm.gorusulenKisi == "" ||
        vm.personelNotu == "" ||
        vm.musteriNotlari == ""
      ) {
        vs.notify({
          title: "Uyarı",
          text: "Boş alanlar bulunuyor",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
          position: "top-center"
        });
      } else {
        var args = {
          token: Store.state.tokenId,
          gorusmeTipi: vm.gorusmeTipi.name,
          gorusmeTarihi: vm.gorusmeTarihi,
          gorusulenKisi: vm.gorusulenKisi,
          personelNotu: vm.personelNotu,
          musteriNotu: vm.musteriNotlari,
          employeeId: Store.state.employeeid,
          ACTID: vm.ACTID
        };
        soap.createClient(url, function(err, client) {
          client.INT_INS_GORUSME(args, function(err, result) {
            if (result.INT_INS_GORUSMEResult == "-1") {
              Store.dispatch("logout");
              //this.$store.dispatch('login', payload)
            }
            try {
              vm.veriler = JSON.parse(result.INT_INS_GORUSMEResult);
              if (vm.veriler.response == "Ok") {
                vs.notify({
                  title: "Başarılı",
                  text: vm.veriler.message,
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "success",
                  position: "top-center"
                });
                vm.gorusmeTipi = "";
                vm.gorusulenKisi = "";
                vm.musteriNotlari = "";
                vm.gorusulenAciklama = "";
                vm.personelNotu = "";
                vm.gorusmeTarihi = "";
                vm.$refs["modal-gorusme"].hide();
              } else {
                vs.notify({
                  title: "Uyarı",
                  text: vm.veriler.message,
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "warning",
                  position: "top-center"
                });
              }
            } catch (error) {}
          });
        });
      }
    },
    gorusmeKaydiOlustur() {
      this.$refs["modal-gorusme"].show();
    },
    ilgiliKisiKaydet(gelen) {
      var vm = this;
      var vs = this.$vs;
      const soap = require("soap");
      const url = state.sistemAddress;

      var args = {
        token: Store.state.tokenId,
        ilgiliKisiAd: vm.ilgiliKisiAd,
        ilgiliKisiSoyad: vm.ilgiliKisiSoyad,
        ilgiliKisiUnvan: vm.ilgiliKisiUnvan,
        ilgiliKisiTelefon: vm.ilgiliKisiTelefon,
        ilgiliKisiCepTelefon: vm.ilgiliKisiCepTelefon,
        ilgiliKisiEmail: vm.ilgiliKisiEmail,
        userId: Store.state.UserId,
        ilgiliKisiId: gelen,
        ACTID: vm.ACTID
      };
      soap.createClient(url, function(err, client) {
        client.INT_INS_ILGILI_KISI(args, function(err, result) {
          if (result.INT_INS_ILGILI_KISIResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          try {
            vm.veriler = JSON.parse(result.INT_INS_ILGILI_KISIResult);
            if (vm.veriler.response == "Ok") {
              vs.notify({
                title: "Başarılı",
                text: vm.veriler.message,
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "success",
                position: "top-center"
              });
              vm.ilgiliKisiAd = "";
              vm.ilgiliKisiSoyad = "";
              vm.ilgiliKisiUnvan = "";
              vm.ilgiliKisiTelefon = "";
              vm.ilgiliKisiCepTelefon = "";
              vm.ilgiliKisiEmail = "";
              vm.$refs["modal-kisiekle"].hide();
            } else {
              vs.notify({
                title: "Uyarı",
                text: vm.veriler.message,
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "warning",
                position: "top-center"
              });
            }
          } catch (error) {}
        });
      });
    },
    cancel() {
      this.$refs["modal-kisiekle"].hide();
      this.ilgiliKisiAd = "";
      this.ilgiliKisiSoyad = "";
      this.ilgiliKisiUnvan = "";
      this.ilgiliKisiTelefon = "";
      this.ilgiliKisiCepTelefon = "";
      this.ilgiliKisiEmail = "";

      this.gorusmeTipi = "";
      this.gorusulenKisi = "";
      this.musteriNotlari = "";
      this.gorusulenAciklama = "";
      this.personelNotu = "";
      this.gorusmeTarihi = "";

      this.aktiviteSaati = "";
      this.aktiviteTarihi = "";
      this.aktiviteNotu = "";
      this.aktiviteDurumu = "";
      this.aktiviteTipi = "";
      this.aktiviteAlici = "";
    },
    kisiEkle() {
      this.$refs["modal-kisiekle"].show();
    },
    faturaDetay(event) {
      var vm = this;
      vm.tableValidate = "Aktiviteler";
      const soap = require("soap");
      const url = state.sistemAddress;
      var args = {
        token: Store.state.tokenId,
        RECEIPTNO: event.data.FISNO
      };

      soap.createClient(url, function(err, client) {
        client.INT_ACTEKS_CARIHAREKET_FATURA(args, function(err, result) {
          if (result.INT_ACTEKS_CARIHAREKET_FATURAResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          try {
            vm.veriler = JSON.parse(result.INT_ACTEKS_CARIHAREKET_FATURAResult);

            var list = JSON.parse(vm.veriler.jsonData);
            var deger = list[0].Column1;
            window.open(userJson.faturaUrl + deger, "_blank");
          } catch (error) {}
        });
      });
    },
    mailBtnGonder(mail) {
      const vs = this.$vs;
      const soap = require("soap");
      const url = state.sistemAddress;
      var args = {};
      vs.loading({
        background: "#0064fa",
        color: "#fff",
        container: "#button-with-loading-yeni",
        scale: 0.45
      });

      if (this.girilenMail != "") {
        if (this.validateEmail(this.girilenMail)) {
          args = {
            ALICI: this.girilenMail + ", " + "muhasebe@canergroup.com.tr",
            MESAJ: this.$refs.ekstreRef.$el.innerHTML,
            KONU: "Tahsilat bilgilendirme"
          };
        } else {
          vs.loading.close("#button-with-loading-yeni > .con-vs-loading");
          vs.notify({
            title: "Hata",
            text: "Mail adresinin doğru olduğundan emin olun.",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-center"
          });
        }
      } else if (this.girilenMail == "") {
        if (mail != "" && typeof mail != "undefined") {
          args = {
            ALICI: mail + ", " + "muhasebe@canergroup.com.tr",
            MESAJ: this.$refs.ekstreRef.$el.innerHTML,
            KONU: "Tahsilat bilgilendirme"
          };
        } else {
          vs.loading.close("#button-with-loading-yeni > .con-vs-loading");
          vs.notify({
            title: "Hata",
            text: "Mail adresi giriniz.",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-center"
          });
        }
      }

      soap.createClient(url, function(err, client) {
        client.mailGonder(args, function(err, result) {
          var vm = this;
          if (result.mailGonderResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          try {
            vm.veriler = JSON.parse(result.mailGonderResultResult);
            if (vm.veriler.response == "Ok") {
              vs.loading.close("#button-with-loading-yeni > .con-vs-loading");
              vs.notify({
                title: "Mail",
                text: "Mail başarıyla gönderildi." + vm.veriler.message,
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "success",
                position: "top-center"
              });
            }
          } catch (error) {
            vs.loading.close("#button-with-loading-yeni > .con-vs-loading");
            vs.notify({
              title: "Mail",
              text: "Mail göndermede hata oluştu." + vm.veriler.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center"
            });
          }
        });
      });
      this.girilenMail = "";
    },
    mailList() {
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId,
        ACTID: vm.ACTID
      };
      soap.createClient(url, function(err, client) {
        client.INT_Ls_Act_ContactList(args, function(err, result) {
          if (result.INT_Ls_Act_ContactListResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          vm.veriler = JSON.parse(result.INT_Ls_Act_ContactListResult);

          vm.mailListesi = vm.veriler;
        });
      });
    },
    validateEmail(emailgelen) {
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(emailgelen)) {
        return true;
      } else {
        return false;
      }
    },
    ekstreMailGonder() {
      this.popupEkstreDetay = true;
      this.mailList();
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
    },
    currencyFormatter(currency, sign) {
      if (currency == "") {
        return 0.0;
      } else {
        var sansDec = currency.toFixed(2);
        var formatted = sansDec.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return sign + `${formatted}`;
      }
    },
    onFirstDataRendered(params) {
      params.api.sizeColumnsToFit();
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
    },
    parseDate(date) {
      return moment(String(date)).format("DD.MM.YYYY");
    },
    tahsilatOzet() {
      this.popupKartDetay = true;

      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId,
        ACTID: this.ACTID
      };
      var vm = this;
      vm.gruplananActname = [];
      vm.gruplananACT = [];
      soap.createClient(url, function(err, client) {
        client.INT_TAHSILAT_RAPORU_GENEL(args, function(err, result) {
          if (result.INT_TAHSILAT_RAPORU_GENELResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          vm.veriler = JSON.parse(result.INT_TAHSILAT_RAPORU_GENELResult);
          vm.rowData = JSON.parse(vm.veriler.jsonData);
          var sorted = _.orderBy(vm.rowData, "TARIH", "desc");

          var actnameGrup = _.groupBy(sorted, veri =>
            JSON.stringify({ ACTNAME: vm.parseDate(veri.TARIH) })
          );

          const gruplanmisAylarListesi = Object.keys(actnameGrup);
          gruplanmisAylarListesi.forEach((key, i) => {
            var pazaryeriyillar = actnameGrup[key];
            vm.gruplananActname.push(pazaryeriyillar);
          });

          for (var index = 0; index < vm.gruplananActname.length; index++) {
            var altGrup = [];
            for (var i = 0; i < vm.gruplananActname[index].length; i++) {
              altGrup.push({
                ISLEM: vm.gruplananActname[index][i].ISLEM,
                TTUR: vm.gruplananActname[index][i].TTUR,
                FAY: vm.gruplananActname[index][i].FAY,
                FYIL: vm.gruplananActname[index][i].FYIL,
                BAY: vm.gruplananActname[index][i].BAY,
                BYIL: vm.gruplananActname[index][i].BYIL,
                BTUTAR: vm.gruplananActname[index][i].BTUTAR,
                TVADE: vm.gruplananActname[index][i].TVADE,
                TGUN: vm.gruplananActname[index][i].TGUN,
                TTUTAR: vm.gruplananActname[index][i].TTUTAR,
                BORCTOPLAM: vm.gruplananActname[index][i].BORCTOPLAM,
                ALACAKTOPLAM: vm.gruplananActname[index][i].ALACAKTOPLAM,
                BORCVADE: vm.gruplananActname[index][i].BORCVADE,
                ALACAKVADE: vm.gruplananActname[index][i].ALACAKVADE,
                ACIKLAMA: vm.gruplananActname[index][i].ACIKLAMA
              });
            }

            vm.gruplananACT.push({
              mode: "span",
              label: vm.parseDate(vm.gruplananActname[index][0].TARIH),
              html: false,
              children: altGrup
            });
          }
        });
      });
    },
    tahsilat() {
      /*
      var itemsll = this.$store.state.account.ITEMLIST;

      itemsll.forEach((val, ind) => {
        this.$store.commit("account/REMOVE_ITEM", val.id);
      });*/

      this.listeleValidate = true;
      this.tahsilatValidate = false;
      this.$store.commit("account/CARI_TAHSILAT_GECVADE_VALIDATE", false);
      this.$store.commit("account/CARI_TAHSILAT_GECVADE", "");
      this.$refs.tahsilatList.tahsilatGenelCek(
        this.datepickerbaslangic,
        this.datepickerbitis
      );
      this.$refs.tahsilatList.tahsilatCek(
        this.datepickerbaslangic,
        this.datepickerbitis
      );
    },
    getNow() {
      const today = new Date();
      const date =
        today.getDate() +
        "." +
        (today.getMonth() + 1) +
        "." +
        today.getFullYear();

      const dateTime = date;
      return dateTime;
    },
    getLastTreeMonth() {
      var d = new Date();
      d.setMonth(d.getMonth() - 3);
      return d.toLocaleDateString();
    },
    listele() {
      /*  var itemsll = this.$store.state.account.ITEMLIST;

      itemsll.forEach((val, ind) => {
        this.$store.commit("account/REMOVE_ITEM", val.id);
      });*/
      this.cariHareketlerList();
    },
    createData(count, prefix) {
      var result = [];
      result.push({
        TRANSDATE: "",
        VADE: "",
        ISLEMTURU: "",
        FISNO: "",
        DESCRIPTION: "",
        BORC: this.topBORC,
        ALACAK: this.topALACAK,
        KumulatifBakiye: this.topBAKIYE,
        BAkTip: ""
      });

      return result;
    },
    vadefarkgunDetay() {
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId,
        ACTID: this.ACTID
      };
      var vm = this;
      soap.createClient(url, function(err, client) {
        client.INT_VADEFARKGUN(args, function(err, result) {
          if (result.INT_VADEFARKGUNResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          vm.veriler = JSON.parse(result.INT_VADEFARKGUNResult);
          let vadefarkdetay = JSON.parse(vm.veriler.jsonData);
         
          vm.SATISVADE = vadefarkdetay[0].SATISVADE;
          vm.ORTALAMAVADE = vadefarkdetay[0].ORTALAMAVADE;
          vm.TAHSILATVADE = vadefarkdetay[0].TAHSILATORTALAMAVADE;
          const _MS_PER_DAY = 1000 * 60 * 60 * 24;
          function dateDiffInDays(a, b) {
            a = new Date(a);
            b = new Date(b);

            // Discard the time and time-zone information.
            const utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
            const utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());
            return Math.floor((utc2 - utc1) / _MS_PER_DAY);
          }
          vm.hesaplananGun = dateDiffInDays(vm.SATISVADE, vm.TAHSILATVADE);
          
        });
      });
    },

    cariHareketlerList() {
      this.listeleValidate = false;
      this.tahsilatValidate = true;

      var vm = this;
      vm.topBORC = 0.0;
      vm.topALACAK = 0.0;
      vm.topBAKIYE = 0.0;
      var bitis, baslangic;
      const soap = require("soap");
      const url = state.sistemAddress;

      if (this.datepickerbaslangic == "") {
        baslangic = vm.getLastTreeMonth();
      } else
        baslangic = moment(String(this.datepickerbaslangic)).format(
          "DD.MM.YYYY"
        );
      if (this.datepickerbitis == "") {
        bitis = vm.getNow();
      } else bitis = moment(String(this.datepickerbitis)).format("DD.MM.YYYY");

      //ay.gün.yıl
      const args = {
        token: this.$store.state.tokenId,
        ACTID: this.$store.state.account.ACTID,
        ILKTARIH: baslangic,
        TRANSTYPE: "101",
        SONTARIH: bitis
      };
      
      soap.createClient(url, function(err, client) {
        client.INT_ACTEKS_CARIHAREKET(args, function(err, result) {
          if (result.INT_ACTEKS_CARIHAREKETResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          vm.veriler = JSON.parse(result.INT_ACTEKS_CARIHAREKETResult);
          vm.cariHareketlerListesi = vm.veriler;
          vm.cariHareketlerListesi.forEach((val, index) => {
            vm.topBORC += val.BORC;
            vm.topALACAK += val.ALACAK;
          });
          vm.topBAKIYE =
            vm.cariHareketlerListesi[
              vm.cariHareketlerListesi.length - 1
            ].KumulatifBakiye;
          vm.$store.commit("account/CARI_EKSTRE_TOPLAMBORC", vm.topBORC);
          vm.$store.commit("account/CARI_EKSTRE_TOPLAMALACAK", vm.topALACAK);
          vm.$store.commit("account/CARI_EKSTRE_TOPLAMBAKIYE", vm.topBAKIYE);

          vm.pinnedBottomRowData = vm.createData(1, "Bottom");

          vm.$store.commit(
            "account/CARI_EKSTRE_LIST",
            vm.cariHareketlerListesi
          );
          vm.$store.commit("account/CARI_EKSTRE_BASLANGIC", baslangic);
          vm.$store.commit("account/CARI_EKSTRE_BITIS", bitis);
        });
      });
    }
  },

  components: {
    IlgiliKisiButon,
    CariTahsilatEkstreMail,
    AgGridVue,
    VBModal,
    TahsilatComponent,
    BFormDatepicker,
    BButton,
    BModal,
    BTabs,
    BTab,
    BCardText,
    "v-select": vSelect
  },
  created() {
    const data = [];

    data["servisAdresi"] = localStorage.getItem("servisAdresi");
    data["id"] = localStorage.getItem("id");
    data["employeeid"] = localStorage.getItem("employeeid");
    data["firmaAdi"] = localStorage.getItem("firmaAdi");
    data["COMPANYNAME"] = user.userName;

    data["tokenId"] = localStorage.getItem("tokenId");

    data["COMPANYID"] = localStorage.getItem("COMPANYID");
    data["EMPLOYEENO"] = localStorage.getItem("EMPLOYEENO");
    data["EMAIL"] = localStorage.getItem("EMAIL");
    data["USERLONGNAME"] = localStorage.getItem("USERLONGNAME");
    var result = localStorage.getItem("tokenId").substring(1, 7);
    data["mailCode"] = result;
    data["loginpng"] = user.userLogo;
    data["GROUPCODE"] = localStorage.getItem("GROUPCODE");

    this.$store.commit("setToken", data);
    this.localeText = this.$store.state.account.AG_GRID_LOCALE_EN;
    this.ACTNAME = localStorage.getItem("CARI_TAHSILAT_ACTNAME");
    this.ACTID = localStorage.getItem("CARI_TAHSILAT_ACTID");
    this.$store.commit("account/ITEM_ACTID", this.ACTID);
    //  this.$store.state.account.ACTID = ACTID;
    this.$store.commit("account/ITEM_ACTNAME", this.ACTNAME);
    this.cariHareketlerList();
    this.vadefarkgunDetay();
    this.getRowStyle = params => {
      if (params.node.rowPinned) {
        return { "font-weight": "bold", "background-color": "#E9E9E9" };
      }
    };

    //   this.cariHareketlerList();
    //    alert(Store.state.account.ACTNAME);
    //
  },
  mounted() {
    //tables global olarak tanımlanıyor
    this.$root.$on("ilgiliKisiListesi", () => {
      this.ilgiliKisilerListele();
    });
    this.$root.$on("ilgiliKisiDuzenle", params => {
      // this.ilgiliKisiKaydet();
    });
    this.$root.$on("tahsilatOzetListesiM", () => {
      this.tahsilatOzet();
    });
  },
  beforeDestroy() {
    this.$root.$off("ilgiliKisiListesi");
    this.$root.$off("ilgiliKisiDuzenle");
    this.$root.$off("tahsilatOzetListesiM");
  },
  beforeMount() {
    this.cariHareketlerListesicolumns = [
      {
        headerName: "Tarih",
        field: "TRANSDATE",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },
      {
        headerName: "Vade",
        sortable: true,
        filter: "agDateColumnFilter",
        field: "VADE",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        valueFormatter: params => this.parseDate(params.data.VADE)
      },
      {
        headerName: "İşlem Tipi",
        field: "ISLEMTURU",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },
      {
        headerName: "Fiş No",
        field: "FISNO",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },
      {
        headerName: "Açıklama",
        field: "DESCRIPTION",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },
      {
        headerName: "Borç",
        field: "BORC",
        valueFormatter: this.parseDate,
        sortable: true,
        filter: "agNumberColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        type: "rightAligned",
        valueFormatter: params => this.currencyFormatter(params.data.BORC, "₺")
      },
      {
        headerName: "Alacak",
        field: "ALACAK",
        sortable: true,
        filter: "agNumberColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        type: "rightAligned",
        valueFormatter: params =>
          this.currencyFormatter(params.data.ALACAK, "₺")
      },
      {
        headerName: "Bakiye",
        field: "KumulatifBakiye",
        sortable: true,
        filter: "agNumberColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        type: "rightAligned",
        valueFormatter: params =>
          this.currencyFormatter(params.data.KumulatifBakiye, "₺")
      },
      {
        headerName: "Bakiye Tipi",
        field: "BakTip",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      }
    ];
    this.ilgiliKisilerColumn = [
      {
        width: 200,
        field: "",
        cellRendererFramework: "IlgiliKisiButon"
      },
      {
        headerName: "Ad",
        field: "NAME",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },
      {
        headerName: "Soyad",
        sortable: true,
        filter: "agDateColumnFilter",
        field: "SURNAME",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },
      {
        headerName: "Ünvan",
        field: "MISSION",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },
      {
        headerName: "E-Mail",
        field: "EMAIL",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },
      {
        headerName: "Telefon",
        field: "PHONE1",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },
      {
        headerName: "GSM",
        field: "PHONE3",
        sortable: true,
        filter: "agNumberColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      }
    ];
    this.gorusmelerColumn = [
      {
        headerName: "Tarih",
        field: "TRANSDATE",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },
      {
        headerName: "Görüşme Tarihi",
        sortable: true,
        filter: "agDateColumnFilter",
        field: "EVENTDATE",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },
      {
        headerName: "Tür",
        field: "EVENT",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },
      {
        headerName: "Görüşülen Kullanıcı",
        field: "EMPLOYEENAME",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },
      {
        headerName: "Görüşülen Kişi",
        field: "DESCRIPTION1",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },
      {
        headerName: "Personel Notu",
        field: "DESCRIPTION2",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },
      {
        headerName: "Müşteri Notu",
        field: "DESCRIPTION3",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      }
    ];
    this.aktivitelerColumn = [
      {
        headerName: "Aktivite Oluşturan",
        field: "EMPLOYEENAME",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },
      {
        headerName: "Alıcı",
        sortable: true,
        filter: "agDateColumnFilter",
        field: "ALICI",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },
      {
        headerName: "Görüşülecek Müşteri",
        field: "CRMCONTACTSFULLNAME",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },
      {
        headerName: "Aktivite Notu",
        field: "NOTES",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },
      {
        headerName: "Aktivite Tipi",
        field: "ACTIVITYTYPENAME",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },
      {
        headerName: "Aktivite Durumu",
        field: "STATUSNAME",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      }
    ];
  }
};
</script>
<style lang="scss">
#modal-primary___BV_modal_outer_ {
  z-index: 105000 !important;
}

[dir="ltr"] .modal .modal-header,
[dir="rtl"] .modal .modal-header {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

[dir] .modal .modal-header {
  background-color: #f8f8f8;
  border-bottom: none;
}

[dir="ltr"] .modal-header,
[dir="rtl"] .modal-header {
  border-top-left-radius: calc(0.358rem - 1px);
  border-top-right-radius: calc(0.358rem - 1px);
}

[dir] .modal-header {
  padding: 0.8rem 1.4rem;
  border-bottom: 1px solid #ebe9f1;
}

[dir="ltr"] .modal .modal-header .close:active,
[dir="ltr"] .modal .modal-header .close:focus,
[dir="ltr"] .modal .modal-header .close:hover {
  -webkit-transform: translate(5px, 3px);
  transform: translate(5px, 3px);
}

[dir] .modal .modal-header .close:active,
[dir] .modal .modal-header .close:focus,
[dir] .modal .modal-header .close:hover {
  -webkit-box-shadow: none;
  box-shadow: none;
}

.modal.modal-primary .modal-header .close {
  color: #7367f0 !important;
}

.modal .modal-header .close:active,
.modal .modal-header .close:focus,
.modal .modal-header .close:hover {
  opacity: 1;
  outline: none;
}

[dir="ltr"] .modal-header .close {
  margin: -0.8rem -1.4rem -0.8rem auto;
}

[dir] .modal .modal-header .close {
  padding: 0.2rem 0.62rem;
  -webkit-box-shadow: 0 5px 20px 0 rgb(34 41 47 / 10%);
  box-shadow: 0 5px 20px 0 rgb(34 41 47 / 10%);
  border-radius: 0.357rem;
  background: #fff;
}

.modal-header {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: start;
  -ms-flex-align: start;
  align-items: flex-start;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
}

#modal-primary___BV_modal_outer_ {
  z-index: 105000 !important;
}

[dir] .modal-title {
  margin-bottom: 0;
  color: #7367f0 !important;
}

[dir="ltr"] .modal .modal-header,
[dir="rtl"] .modal .modal-header {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

[dir] .modal .modal-header {
  background-color: #f8f8f8;
  border-bottom: none;
}

[dir="ltr"] .modal-header,
[dir="rtl"] .modal-header {
  border-top-left-radius: calc(0.358rem - 1px);
  border-top-right-radius: calc(0.358rem - 1px);
}

[dir] .modal-header {
  padding: 0.8rem 1.4rem;
  border-bottom: 1px solid #ebe9f1;
}

[dir="ltr"] .modal .modal-header .close:active,
[dir="ltr"] .modal .modal-header .close:focus,
[dir="ltr"] .modal .modal-header .close:hover {
  -webkit-transform: translate(5px, 3px);
  transform: translate(5px, 3px);
}

[dir] .modal .modal-header .close:active,
[dir] .modal .modal-header .close:focus,
[dir] .modal .modal-header .close:hover {
  -webkit-box-shadow: none;
  box-shadow: none;
}

.modal.modal-primary .modal-header .close {
  color: #7367f0 !important;
}

.modal .modal-header .close:active,
.modal .modal-header .close:focus,
.modal .modal-header .close:hover {
  opacity: 1;
  outline: none;
}

[dir="ltr"] .modal-header .close {
  margin: -0.8rem -1.4rem -0.8rem auto;
}

[dir] .modal .modal-header .close {
  padding: 0.2rem 0.62rem;
  -webkit-box-shadow: 0 5px 20px 0 rgb(34 41 47 / 10%);
  box-shadow: 0 5px 20px 0 rgb(34 41 47 / 10%);
  border-radius: 0.357rem;
  background: #fff;
}

.modal-header {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: start;
  -ms-flex-align: start;
  align-items: flex-start;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
}

.my-fancy-class {
  background-color: #7367f0;
}
</style>
